import { render, staticRenderFns } from "./BucketSync.vue?vue&type=template&id=2513ae7e&scoped=true"
import script from "./BucketSync.vue?vue&type=script&lang=js"
export * from "./BucketSync.vue?vue&type=script&lang=js"
import style0 from "./BucketSync.vue?vue&type=style&index=0&id=2513ae7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2513ae7e",
  null
  
)

export default component.exports